import React, { useRef } from 'react';
import { Flex, type ListRef } from '@banhala/ui-kit';
import { AtomicRenderer } from 'shared/src/component';
import { useGoodsDetailAtomics } from '../queries/useGoodsDetailAtomics';
import type { IScreensComponent } from 'shared/src/api';
import { isNil } from 'shared/src/utils';

export const GoodsAtomicRenderer: React.FC<{
  focused: boolean;
  screen: string;
  onChangeHeight: (height: number) => void;
}> = props => {
  const { data: atomic, isLoading, refetch } = useGoodsDetailAtomics(true);
  const ref = useRef<ListRef<IScreensComponent>>(null);

  if (isNil(atomic)) return null;

  return (
    <Flex
      onLayout={({ nativeEvent }) => {
        props.onChangeHeight(nativeEvent.layout.height);
      }}
    >
      <AtomicRenderer
        listRef={ref}
        hideScrollToTop={true}
        data={atomic}
        fetchNextPage={() => {}}
        scrollToFilterList={() => {}}
        isFetching={isLoading}
        refetch={refetch}
        screen={props.screen}
      />
    </Flex>
  );
};
